import { Typography } from '@material-ui/core';
import React from 'react';
import Layout from '../../Layout';
import { Box } from '../../UI';
import NavigateBack from '../../UI/NavigateBack';
import data from '../../../utils/dbSchema';
import PageTitle from '../../Layout/PageTitle'

export default function QnA({ match }) {
	const propertyData = data.properties.find(property => {
		return match.params.id === property.id;
    });
	return (
		<Layout>
			<Box p="30px">
				<PageTitle title={'Q&A page'} action={<NavigateBack slug={`/market-search/${propertyData.id}`} />}>
				</PageTitle>
			</Box>
		</Layout>
	);
}
